@for (fieldValue of fieldValues; track fieldValue) {
  <div style="margin: 3px 30px 0 0;display: inline-block;">
    {{ fieldValue.name }}:
    <strong>
      @switch (fieldValue.data_type) {
        @case ('Option') {
          {{ fieldValue.value === true ? 'Ja' : 'Nein' }}
        }
        @case ('Ganzzahl') {
          @if (typeof fieldValue.value !== 'boolean') {
            {{ fieldValue.value | money }}
          }
        }
        @case ('Kommazahl') {
          @if (typeof fieldValue.value !== 'boolean') {
            {{ fieldValue.value | money }}
          }
        }
        @default {
          {{ fieldValue.value }}
        }
      }
    </strong>
  </div>
}
